import React, { Fragment, useState } from "react";
import SideBar from "./SideBar";
import Header from "./Header";

/* NavHader used to render here: the logo rail, a fixed box in the
   top-left corner the same width as the sidebar but living in the
   topbar's row. The brand is the sidebar's own head now (SideBar.jsx),
   so there is nothing left for a separate rail to hold. */
const JobieNav = ({ title, onClick: ClickToAddEvent, onClick2, onClick3 }) => {
  const [toggle, setToggle] = useState("");
  const onClick = (name) => setToggle(toggle === name ? "" : name);
  return (
    <Fragment>
      <Header
        onNote={() => onClick("chatbox")}
        onNotification={() => onClick("notification")}
        onProfile={() => onClick("profile")}
        toggle={toggle}
        title={title}
        onBox={() => onClick("box")}
        onClick={() => ClickToAddEvent()}
      />
      <SideBar />
    </Fragment>
  );
};

export default JobieNav;
